module.exports = __webpack_public_path__ + "assets/img/WingPay.02dca23b.png";